<template>
	<Menu as="div" class="relative ml-3" data-testid="account-menu">
		<div>
			<MenuButton
				v-if="authStore.user"
				class="relative flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
				<span class="absolute -inset-1.5" />
				<span class="sr-only">Open user menu</span>
				<span
					class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-mabey-400">
					<span class="text-sm font-medium leading-none text-white">
						{{ authStore.user.initials }}
					</span>
				</span>
			</MenuButton>
		</div>
		<transition
			enter-active-class="transition ease-out duration-100"
			enter-from-class="transform opacity-0 scale-95"
			enter-to-class="transform opacity-100 scale-100"
			leave-active-class="transition ease-in duration-75"
			leave-from-class="transform opacity-100 scale-100"
			leave-to-class="transform opacity-0 scale-95">
			<MenuItems
				data-testid="menu-items"
				class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
				<MenuItem v-slot="{ active }">
					<a
						href="#"
						:class="[
							active ? 'bg-gray-100' : '',
							'block px-4 py-2 text-sm text-gray-700'
						]"
						data-testid="logout"
						@click="authStore.logout()">
						Sign out
					</a>
				</MenuItem>
			</MenuItems>
		</transition>
	</Menu>
</template>

<script lang="ts" setup>
	import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
	import useAuthStore from '@/stores/auth'

	const authStore = useAuthStore()
</script>
